var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 100,
    viewBox: "0 0 70 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddii)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5064 20.5608C56.8781 11.1088 52.3229 8.77701 45.3357 11.7126C33.7066 18.875 23.0797 27.5786 13.7385 37.5911C8.09094 43.1499 7.41077 52.5603 13.7385 60.7424C26.4969 72.9842 38.9049 84.6848 47.3144 88.5155C54.3841 91.2637 57.8262 88.0367 58.5064 80.1877C59.7519 60.332 59.7519 40.4166 58.5064 20.5608Z",
    fill: "#E3C19A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.9721 26.3282C52.6324 18.5833 48.8193 16.772 43.1717 19.083C33.6454 24.9501 24.9389 32.0781 17.2839 40.2772C12.6669 44.8367 12.0898 52.5399 17.2839 59.2437C27.7338 69.3412 37.8952 78.8765 44.8 82.0202C50.5918 84.2687 53.4156 81.6246 53.9721 75.2331C54.9934 58.9478 54.9934 42.6135 53.9721 26.3282Z",
    fill: "#FBF4ED"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddii",
    x: 2.24414,
    y: 3.52295,
    width: 64.1964,
    height: 92.9577,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.227451 0 0 0 0 0.0666667 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.227451 0 0 0 0 0.0666667 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.227451 0 0 0 0 0.0666667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.227451 0 0 0 0 0.0666667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow",
    result: "effect4_innerShadow"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveLeft);
export default __webpack_public_path__ + "static/media/move-left.d85907f0e35b658e46c410652d7dfb53.svg";
export { ForwardRef as ReactComponent };